.notConnected {
  color: red;
}

.connected {
  color: green;
}
